import React from 'react';
import { useTranslation } from 'react-i18next';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';

import _ from 'lodash';
import Alert from '~/commons/components/Alert.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';
import FieldArrayIterables from '~/commons/components/FieldArrayIterables.jsx';
import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';
import FieldsQtnOpts from './article/FieldsQtnOpts.jsx';

const FieldsArticleQtns = ({
  article,
  defaultQtn,
  fileUploadUrl,
}) => {
  const hasAns = article ? (article.answers.length > 0 && _.some(article.answers, (v) => v.status === 'answering')) : false;
  const { t } = useTranslation();
  console.log({ hasAns, article });
  return (
    <>
      {hasAns && (
        <Alert theme="warning">
          Some of the users have already answered these questions.
          Only limited changes can be made.
        </Alert>
      )}
      <FieldArrayIterables
        name="questions"
        {...hasAns ? {} : {
          push: defaultQtn,
        }}
      >
        {(q, i, { remove }) => (
          <div key={i} className="card mb-3 p-3">
            {!hasAns && (
              <button
                className="btn btn-link close"
                onClick={() => remove(i)}
              >
                <FA icon={faTimes} size="sm" />
              </button>
            )}
            <div className="card-body">
              <div className="row">
                <div className="col">
                  <FormGroup
                    as="summernote"
                    fileUploadUrl={fileUploadUrl}
                    name={`questions.${i}.question`}
                    label={<><b>{i + 1}</b>. {t('Question')}</>}
                    height={195}
                    essentials
                    required
                  />
                </div>
                <div className="col">
                  <FormGroup
                    className="contain"
                    name={`questions.${i}.img`}
                    as="coverImg"
                    label={<>{t('Image')} ({t('Suggested Dimension')}: 1280 x 960px)</>}
                    api={fileUploadUrl}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <FormGroup
                    as="select"
                    name={`questions.${i}.format`}
                    label="Format"
                  >
                    <option value="single-select">{t('Single Select')}</option>
                    <option value="multi-select">{t('Multi Select')}</option>
                    {/* <option value="ordering">{t('Ordering')}</option> */}
                    <option value="matching">{t('Matching')}</option>
                  </FormGroup>
                </div>
                <div className="col">
                  <FormGroup
                    as="select"
                    name={`questions.${i}.score`}
                    label={t('Score')}
                  >
                    <option value="">-</option>
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                  </FormGroup>
                </div>
                <div className="col">
                  <div className="form-group">
                    <label>{'啟動隨機答案選項排序'}</label>
                    <FormCheckGroup
                      name={`questions.${i}.randomAnswers`}
                      type="checkbox"
                      label=""
                      asSwitch
                    />
                  </div>
                </div>
              </div>
              <FieldsQtnOpts
                qtnIndex={i}
                restrictEdit={hasAns}
                fileUploadUrl={fileUploadUrl}
              />
            </div>
          </div>
        )}
      </FieldArrayIterables>
    </>
  );
};

export default FieldsArticleQtns;
